<div class="scheduler-events-table-wrapper">
    <ng-container *ngIf="rows().length > 0; else emptyState">
        <table mat-table [dataSource]="rows()" class="events-table">

            <!-- # — flat index across the whole sequence; matches the Gantt's row order. -->
            <ng-container matColumnDef="index">
                <th mat-header-cell *matHeaderCellDef class="nowrap">#</th>
                <td mat-cell *matCellDef="let r" class="nowrap">{{ r.flatIndex + 1 }}</td>
            </ng-container>

            <!-- Event id (truncated) + "execution n of m" badge for multi-execution events.
                 The badge surfaces continuation-mode events without forcing extra columns. -->
            <ng-container matColumnDef="eventId">
                <th mat-header-cell *matHeaderCellDef class="nowrap">Event</th>
                <td mat-cell *matCellDef="let r" class="nowrap">
                    <span class="event-id" [matTooltip]="r.eventId">{{ shortId(r.eventId) }}</span>
                    <span class="exec-badge" *ngIf="r.executionsInEvent > 1"
                          matTooltip="Execution {{ r.executionIndexWithinEvent }} of {{ r.executionsInEvent }} in this event (continuation mode)">
                        {{ r.executionIndexWithinEvent }}/{{ r.executionsInEvent }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="originalFireTime">
                <th mat-header-cell *matHeaderCellDef class="nowrap">Scheduled at</th>
                <td mat-cell *matCellDef="let r" class="nowrap">
                    {{ r.originalFireTime ? (r.originalFireTime | date:'yyyy-MM-dd HH:mm:ss') : '—' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="simulatedStart">
                <th mat-header-cell *matHeaderCellDef class="nowrap">Sim. start</th>
                <td mat-cell *matCellDef="let r" class="nowrap">
                    {{ r.sim.start ? (r.sim.start | date:'yyyy-MM-dd HH:mm:ss.SSS') : '—' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="simulatedEnd">
                <th mat-header-cell *matHeaderCellDef class="nowrap">Sim. end</th>
                <td mat-cell *matCellDef="let r" class="nowrap">
                    {{ r.sim.end ? (r.sim.end | date:'yyyy-MM-dd HH:mm:ss.SSS') : '—' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="durationMs">
                <th mat-header-cell *matHeaderCellDef class="nowrap">Duration</th>
                <td mat-cell *matCellDef="let r" class="nowrap mono">{{ formatMs(r.sim.durationMs) }}</td>
            </ng-container>

            <ng-container matColumnDef="driftAppliedMs">
                <th mat-header-cell *matHeaderCellDef class="nowrap">Drift</th>
                <td mat-cell *matCellDef="let r" class="nowrap mono">{{ formatSignedMs(r.sim.driftAppliedMs) }}</td>
            </ng-container>

            <ng-container matColumnDef="jitterAppliedMs">
                <th mat-header-cell *matHeaderCellDef class="nowrap">Jitter</th>
                <td mat-cell *matCellDef="let r" class="nowrap mono">{{ formatSignedMs(r.sim.jitterAppliedMs) }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="nowrap">Status</th>
                <td mat-cell *matCellDef="let r" class="nowrap">
                    <span class="status-pill" [class.status-pill-failed]="r.sim.failed" [class.status-pill-ok]="!r.sim.failed">
                        <mat-icon class="status-icon">{{ r.sim.failed ? 'error' : 'check_circle' }}</mat-icon>
                        {{ r.sim.failed ? 'Failed (sim)' : 'OK (sim)' }}
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.row-failed]="row.sim.failed"></tr>
        </table>
    </ng-container>

    <ng-template #emptyState>
        <div class="events-empty">
            <mat-icon>calendar_today</mat-icon>
            <div>No events for the current schedule definition.</div>
        </div>
    </ng-template>
</div>
